type InfoListProps = {
  items: readonly string[];
};

export function InfoList({ items }: InfoListProps) {
  return (
    <ul className="mt-1 list-disc space-y-1.5 pl-5">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
